import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';

/**
 * The app's table row: zebra stripe, hover, and the archived state. Use it for any table
 * built from MUI parts, or its rows render as bare card.
 *
 * Three bases (plain, striped, archived) as background-color, and hover as a
 * background-image layer over them. Keep stripe and hover on separate tokens.
 */
const StyledTableRow = styled(TableRow)(({ theme }) => {
  const overlay = (theme.vars || theme).palette.rowHoverOverlay;
  return {
    '&:nth-of-type(odd)': {
      backgroundColor: (theme.vars || theme).palette.stripe,
    },
    /**
     * Archived: recessed surface plus the card's amber outline. Both are colour, so the
     * row also needs the "Archived" chip (StickyHeadTable adds it). `outline`, not
     * `border`: it ignores border-collapse and row metrics.
     */
    '&.archived': {
      backgroundColor: (theme.vars || theme).palette.archivedRow,
      outline: `1px solid ${(theme.vars || theme).palette.archived}`,
      outlineOffset: '-1px',
    },
    '&:hover': {
      backgroundImage: `linear-gradient(${overlay}, ${overlay})`,
      '--link': 'var(--link-hover)',
    },
    '& a:hover': {
      textDecoration: 'underline',
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  };
});

export default StyledTableRow;
